import { Empty, Popover, Select } from 'antd'
import styles from './index.module.less'
import { useEffect, useState } from 'react'
import noData from '@/assets/noData.png'

export default function SelectPopover(props: any) {
  const { applyPackageList, setSelectValue, showValue } = props
  const [value, setValue] = useState<any>(undefined)
  const [activeIndex, setActiveIndex] = useState<number>(-1)
  const [open, setOpen] = useState(false)
  useEffect(() => {
    setValue(showValue)
    setSelectValue(showValue)
    setActiveIndex(applyPackageList?.findIndex(item => item.id === showValue))
  }, [showValue, applyPackageList])
  const handleChange = (item, index) => {
    if (index === activeIndex) {
      setActiveIndex(-1)
      setValue(undefined)
      setSelectValue(undefined)
    } else {
      setActiveIndex(index)
      setValue(item.id)
      setSelectValue(item.id)
    }
    setOpen(false)
  }
  const content = () => {
    return (
      <div className={styles.popDiv}>
        {applyPackageList?.length ? (
          <div className={styles.selectPopoverContentBox}>
            {applyPackageList.map((item, index) => {
              return (
                <div
                  className={`${styles.selectPopoverContentItem}  ${activeIndex === index ? styles.selectPopoverContentItemActive : ''}`}
                  onClick={() => {
                    handleChange(item, index)
                  }}
                >
                  {item.name}
                </div>
              )
            })}
          </div>
        ) : (
          <Empty image={noData} description={false}></Empty>
        )}
      </div>
    )
  }
  const handleOpenChange = (open: boolean) => {
    setOpen(open)
  }
  const handleSelectChange = value => {
    console.log(value)
    if (!value) {
      // 清空
      setActiveIndex(-1)
      setValue(undefined)
      setSelectValue(undefined)
    }
  }
  return (
    <div className={styles.selectPopover}>
      <Popover
        content={content}
        title="标配"
        trigger="click"
        open={open}
        placement="bottomLeft"
        arrow={false}
        onOpenChange={handleOpenChange}
      >
        <Select
          value={value}
          style={{ width: 220 }}
          options={applyPackageList}
          fieldNames={{ label: 'name', value: 'id' }}
          open={false}
          placeholder="标配"
          allowClear
          onChange={handleSelectChange}
        />
      </Popover>
    </div>
  )
}
